export default {
	SET_SYSTEM_SETTINGS: 'SET_SYSTEM_SETTINGS',
	SET_ACTIVE_CONTENT: 'SET_ACTIVE_CONTENT',
	SET_SITES: 'SET_SITES',
	SET_USERS: 'SET_USERS',
	// SET_USER: 'SET_USER'
};